import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'

import useCreditFetcher from '../hooks/useCreditFetcher'
import { formatWithThousandSep } from '../utils/utils'
import useDealFetcher from '../hooks/useDealFetcher'
import Deal from '../interfaces/Deal'

import CreditEdit, { CreditFormat } from './CreditEdit'

const CreditEditPage: React.FC = () => {
  // Extracting id parameter from the route
  const { id } = useParams<{ id: string }>()
  const { fetchCreditDetail, errorCredit } = useCreditFetcher()
  const { fetchDealDetail } = useDealFetcher()
  const [credit, setCredit] = useState<CreditFormat | null>(null)
  const [deal, setDeal] = useState<Deal>()

  useEffect(() => {
    const fetchAsync = async () => {
      if (!id) {
        return // Exit early if `id` is undefined
      }

      const credit = await fetchCreditDetail(id)

      if (errorCredit || !credit) return

      // leemos el vehiculo y el cliente que vienen desde el "deal"
      if (credit.deal) {
        const deal = await fetchDealDetail(credit.deal)
        if (deal) setDeal(deal)
      }

      const amount_format = formatWithThousandSep(credit.amount)
      const fee_format = formatWithThousandSep(credit.fee)
      const observations_format = credit?.observations?.join('\n') ?? ''
      const paymentsQty_format = formatWithThousandSep(credit.paymentsQty ?? 0)
      const paymentsAmount_format = formatWithThousandSep(credit.paymentsAmount ?? 0)
      const rate_format = formatWithThousandSep(credit.rate ?? 0)
      const balance_format = formatWithThousandSep(credit.balance ?? 0)
      const price_format = formatWithThousandSep(credit.price ?? 0)
      const salary_format = formatWithThousandSep(credit.salary ?? 0)

      const creditFormat = {
        ...credit,
        amount_format: amount_format,
        fee_format: fee_format,
        observations_format: observations_format,
        paymentsQty_format: paymentsQty_format,
        paymentsAmount_format: paymentsAmount_format,
        rate_format: rate_format,
        balance_format: balance_format,
        price_format: price_format,
        salary_format: salary_format,
      }
      setCredit(creditFormat)
    }

    fetchAsync()
  }, [])

  return (
    <div className="p-4">
      {deal && deal.body && credit && (
        <CreditEdit
          vehicle={deal.body.vehicle}
          client={deal.body.client}
          creditIn={credit}
          modificaSw={true}
          vehicleId=""
          clientId=""
          dealId=""
        />
      )}
    </div>
  )
}
export default CreditEditPage
